import { StringInput } from './StringInput';
import { NumberInput } from './NumberInput';
import { BooleanSelect } from './BooleanSelect';
import { DateSelect } from './DateSelect';
import { useConditionValueInputType } from './hooks/useConditionValueInputType';

export const ConditionValue = () => {
  const { isStringInput, isNumberInput, isBooleanSelect, isDateSelect } =
    useConditionValueInputType();

  if (isStringInput) return <StringInput />;
  if (isNumberInput) return <NumberInput />;
  if (isBooleanSelect) return <BooleanSelect />;
  if (isDateSelect) return <DateSelect />;
  else return null;
};
